import NavigationContainer from './NavigationBarContainer';

export default NavigationContainer;
